module.exports = __webpack_public_path__ + "img/conductor-logo.1780972f.svg";